// Angular
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faSuitcase, IconDefinition } from "@fortawesome/free-solid-svg-icons";
// Afidium
import { Yii } from 'libraries/interfaces/Yii';
import { ILuggageRestriction, LuggageType, RestrictionUnit } from 'libraries/service/resources/model/booking/air/IAirPrice';


@Component({
    selector: 'luggage',
    template: `
        <div [class.inline]="inline">
            <div class="suitcase">
                <fa-icon [icon]="iconSuitcase"></fa-icon>
                {{ this.translatedType }}
                <ng-container *ngIf="quantity">(x{{quantity}})</ng-container>
            </div>
            <div [class.quantity-bold]="isQuantityBolded">
                <em *ngFor="let restrictionItem of filteredRestrictions"
                    [class.alert]="restrictionItem.max == 0">
                    {{restrictionItem.max}}
                    <ng-container *ngIf="restrictionItem.unit">{{ getUnit(restrictionItem.unit) }}</ng-container>
                </em>
            </div>
        </div>

    `,
    styles: [`

        em:not(:last-child)::after {
            content: ' / ';
        }

        .quantity-bold em {
            font-weight: bold;
            color: #414141;
        }
        .inline{
            flex-wrap: wrap;
            display: flex;
        }
        .inline .suitcase{
            white-space: nowrap;
            margin-right: .375rem;
        }
    `]
})
export class LuggageComponent implements OnChanges {
    @Input()
    public restriction: ILuggageRestriction[];
    @Input()
    public quantity: number;
    @Input()
    public type: LuggageType;
    @Input()
    public isQuantityBolded: boolean = false;
    @Input()
    public inline: boolean = true;

    public translatedType: string;

    public iconSuitcase: IconDefinition = faSuitcase;

    public filteredRestrictions: ILuggageRestriction[];

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.restriction || changes.quantity || changes.type) {
            // Get Air returns Cabin et Hold
            const type: string = this.type ? this.type.toLowerCase() : null;

            switch (type) {
                case LuggageType.cabin:
                    this.translatedType = Yii.t("wui-shared-js", "Cabine");
                    break;
                case LuggageType.hold:
                    this.translatedType = Yii.t("wui-shared-js", "Soute");
                    break;
                default:
                    this.translatedType = Yii.t("wui-shared-js", "Type inconnu");
            }

            this.filteredRestrictions = (this.restriction || [])
                .filter((restriction: ILuggageRestriction) => !hasUselessUnit(restriction, this.restriction));
        }
    }

    public getUnit(unit: RestrictionUnit): string {
        // Get Air returns unit in capital
        switch (unit.toLowerCase()) {
            case RestrictionUnit.luggage:
                return Yii.t("wui-shared-js", "PC");
            case RestrictionUnit.kilogram:
                return Yii.t("wui-shared-js", "kg");
            case RestrictionUnit.centimeter:
                return Yii.t("wui-shared-js", "cm");
            case RestrictionUnit.inch:
                return Yii.t("wui-shared-js", "in");
            case RestrictionUnit.pound:
                return Yii.t("wui-shared-js", "lb");
            default:
                return `${unit}`.toLowerCase();
        }
    }
}

function hasUselessUnit(restriction: ILuggageRestriction, restrictions: ILuggageRestriction[]): boolean {
    return (restriction.unit === RestrictionUnit.inch &&
        restrictions
            .map((existingRestriction: ILuggageRestriction) => ({
                ...existingRestriction,
                unit: existingRestriction.unit.toLowerCase()
            }))
            .some((existingRestriction: ILuggageRestriction) => existingRestriction.unit === RestrictionUnit.centimeter)) ||
        (restriction.unit === RestrictionUnit.pound &&
            restrictions.some((existingRestriction: ILuggageRestriction) => existingRestriction.unit === RestrictionUnit.kilogram));
}
